import { create } from "zustand"
import type { HospitalSectionKey } from "@/widgets/hospital-detail/lib/sections"

/**
 * 단일 스크롤 구조라 이 상태는 "지금 보이는 섹션"만 들고 있다 —
 * 본문을 갈아끼우던 selectedTab 과 달리, 값이 틀려도 렌더 결과가 사라지지 않고
 * 상단 내비의 강조 위치만 어긋난다.
 */
interface WidgetsHospitalStore {
  activeSection: HospitalSectionKey
  setActiveSection: (activeSection: HospitalSectionKey) => void
}

const useWidgetsHospitalStore = create<WidgetsHospitalStore>((set) => ({
  activeSection: "overview",
  setActiveSection: (activeSection) => set({ activeSection }),
}))

export default useWidgetsHospitalStore
